import { useState } from 'react';

import type { VirtualDirectoryUnitFragment } from '../../../../../graphql/api/generated';
import { useDebouncedSearch } from '../../../../../hooks/useDebouncedSearch';

interface IUnitFilters {
  directoryStatus?: string[];
  occupancy?: string[];
  unlistedReasons?: string[];
}

export function useVirtualDirectoryUnitFilters(units: VirtualDirectoryUnitFragment[]) {
  const { searchWords, onSearch } = useDebouncedSearch();
  const [filters, setFilters] = useState<IUnitFilters>({});

  let filteredUnits = units;

  if (filters.directoryStatus?.length) {
    filteredUnits = filteredUnits.filter(({ unlistedReasons }) => {
      const directoryStatus = unlistedReasons.length ? 'Unlisted' : 'Listed';

      return !filters.directoryStatus?.length || filters.directoryStatus.includes(directoryStatus);
    });
  }

  if (filters.occupancy?.length) {
    filteredUnits = filteredUnits.filter(u => filters.occupancy?.includes(u.occupancy));
  }

  if (filters.unlistedReasons?.length) {
    filteredUnits = filteredUnits.filter(resident => (
      resident.unlistedReasons.some(reason => filters.unlistedReasons?.includes(reason))
    ));
  }

  if (searchWords.length) {
    const lowerCaseSearchWords = searchWords.map(s => s.toLowerCase());

    filteredUnits = filteredUnits.filter(({ unitDisplayName, users }) => {
      return lowerCaseSearchWords.every((lowerCaseWord) => {
        return (
          users.some(u => u.userFullName?.toLowerCase().includes(lowerCaseWord)) ||
          unitDisplayName.toLowerCase().includes(lowerCaseWord)
        );
      });
    });
  }

  return {
    onSearch,
    setFilters,
    filteredUnits,
  };
}
